<div class="header-title"> 
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
                <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button"> 
                    <span class="u-icon icon-chevron-left"></span>
                    <span class="u-button-text">Back</span>
                </a>
            </div>
            <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
                <h1 class="font-semibold u-ma-0 flex header-title--name">Header</h1>
            </div>
    </div>
    <div class="c-header__gradient"></div>
  </div>
  
  <maced-header headerId="Header0" [links]="headerlinksSpanish" logoImg="./assets/default/images/logo-mee-black-mac.svg" logoImgAltName="Macmillan Education Everywhere Platform"
    logoHyperLink="/" [logoWidth] = 36 [logoHeight] = 48>
  </maced-header>

  <maced-header headerId="Header1" logoImg="./assets/default/images/logo-mee-black-mac.svg" logoImgAltName="Macmillan Education Everywhere Platform"
  logoHyperLink="/" [logoWidth] = 36 [logoHeight] = 48>
</maced-header>
  
  <maced-header headerId="Header2" [links]="headerlinksHindi" logoImg="./assets/default/images/logo-mee-black-mac.svg" logoImgAltName="Macmillan Education Everywhere Platform"
    logoHyperLink="/">
  </maced-header>